import { CustomElement, resolve } from 'aurelia';
import { SubscriptionService } from '../../services';
import template from './subscription-limit-toast.html';
import './subscription-limit-toast.css';

// Transient alert shown when a release reminder could not be set because the user hit their
// per-user reminder cap. Without it the bell just rolls back to "off" after the server's 409 and
// the user gets no explanation. Renders only while SubscriptionService.limitReachedMessage is set;
// that service owns the message, the auto-clear timer, and the manual dismiss.
export class SubscriptionLimitToastElement {
  readonly subscriptions: SubscriptionService = resolve(SubscriptionService);
}

export const SubscriptionLimitToast = CustomElement.define({
  name: 'subscription-limit-toast',
  template
}, SubscriptionLimitToastElement);
